<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  beforeMount() {
    let that = this;
    // this.addVconsole();
  },
  mounted() {
    this.$nextTick(() => {});
  },
  methods: {
    addVconsole(options) {
      this.loadScript({
        src: '//cdn.bootcdn.net/ajax/libs/vConsole/3.15.0/vconsole.min.js',
        success: function () {
          var vConsole = new VConsole();
          console.log('Initial vConsole success', 'version:', vConsole.version);
        }
      });
    },
    loadScript (options) {
      var options = options || {},
          src = options.src || "",
          id = options.id || "",
          success = options.success || "";

      if (id && document.getElementById(id)) {
          success && success();
          return;
      }

      var _doc = document.getElementsByTagName('head')[0];
      var script = document.createElement('script');
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('src', src);
      if (id) {
          script.setAttribute('id', id);
      }
      _doc.appendChild(script);
      if (document.all) {
          if (script.readyState == 'loaded' || script.readyState == 'complete') {
              success && success();
          }
      } else {
          script.onload = function () {
              success && success();
          }
      }
    }
  }
}
</script>

<style lang="scss">
body {
  background: #151A59;
}
#app {
  height: 100vh;
  width: 100vw;
}
::-webkit-scrollbar {
  display: none;
}
// .home {
//   height: 100vh;
//   width: 100vw;
// }

body, div, dl, dt, dd, ul, ol, li, h1, h2, h3, h4, h5, h6, pre, code, form, fieldset, legend, input, textarea, p, blockquote, th, td, hr, button, article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {
  margin: 0;
  padding: 0
}
ul {
  list-style: none;
}
</style>
